<template>
  <div :class="[$style.scrollbig, isEntered ? $style.scrollEntered : $style.scrolledLeaved]">
    <div
      :class="[$style.scrollbigBg, isEntered ? $style.scrollEntered : $style.scrolledLeaved]"
    ></div>
    <div :class="$style.starter"></div>
    <div :class="$style.filler" :style="{ height }" data-filler></div>
    <div
      :class="$style.scrollbigNavigator"
      v-if="$route.name !== 'about-us' && $route.name !== 'tech-features' && $route.name !== 'contact-us'"
    >
      <p :class="$style.scrollbigClose" @click="scrollToTop()" @mouseenter="$hover">close</p>
      <p :class="$style.scrollbigNext" @click="clickRight()" @mouseenter="$hover">next</p>
      <p :class="$style.scrollbigPrev" @click="clickLeft()" @mouseenter="$hover">prev</p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import EventBus from '@/scripts/event-bus'
import { isSafari } from '@/scripts/utils'

export default {
  props: ['containerHeight'],

  computed: {
    ...mapGetters({
      getScrollbar: 'getScrollbar',
      nextPage: 'getNextPage',
      prevPage: 'getPrevPage',
      currentHand: 'currentHand'
    }),

    ...mapState({
      notDouble: 'enableSlider'
    }),

    height() {
      let calc = 0
      let scrollTop = 0


      if (this.getScrollbar) {
        scrollTop = this.getScrollbar.scrollTop
      }

      if (this.$el) {
        if (!isSafari()) this.$el.style.top = `${scrollTop}px`; // eslint-disable-line
        const divideDouble = this.notDouble ? window.innerHeight : (2 * window.innerHeight)

        calc = ((scrollTop - window.innerHeight) * window.innerHeight)
          / (this.containerHeight - divideDouble)
      }

      return `${scrollTop < window.innerHeight ? 0 : calc}px`
    },

    isEntered() {
      let ret = false

      if (this.getScrollbar) {
        const scrollTop = this.getScrollbar.scrollTop
        const res = Math.min(Math.max((scrollTop / window.innerHeight), 0), 1)

        if (res > 0.99) {
          ret = true
        }
      }

      return ret
    }
  },

  methods: {
    clickRight() {
      if (this.$store.state.isInTransition) return
      EventBus.$emit('slideHand', {
        direction: 'right',
        currentHand: this.currentHand(this.nextPage.id),
        fromMenu: false
      })
      this.$router.push(this.nextPage.id)
    },

    clickLeft() {
      if (this.$store.state.isInTransition) return
      EventBus.$emit('slideHand', {
        direction: 'left',
        currentHand: this.currentHand(this.prevPage.id),
        fromMenu: false
      })
      this.$router.push(this.prevPage.id)
    },

    scrollToTop() {
      EventBus.$emit('scrollTo', 0, 1000)
    }
  }
}
</script>


<style module lang="scss">
@import "~sass-mq/mq";

.scrollbig {
  position: sticky;
  top: 0;
  left: 0;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  width: 10px;
  display: none;

  @include mq(sm) {
    width: 114px;
    flex: 0 0 auto;
  }

    @include mq(md) {
      display: inline-block;
    }

  @include mq(ds) {
    width: 190px;
  }

  > .scrollbigBg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background: $color-dark;

    transform-origin: 50% 100%;
    transition: all 0.7s ease-in-out;

    &.scrolledLeaved {
      opacity: 0;
      transform: scaleY(0);
    }

    &.scrollEntered {
      opacity: 1;
      transform: scaleY(1);
    }
  }

  &.scrolledLeaved {
    .scrollbigPrev,
    .scrollbigNext,
    .scrollbigClose {
      font-size: 14px;
      opacity: 0;
      transform: translateY(20px);
    }
  }

  &.scrollEntered {
    .scrollbigPrev,
    .scrollbigNext,
    .scrollbigClose {
      font-size: 14px;
      opacity: 1;
      transform: translateY(0);

      &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 100%;
        bottom: 0;
        margin: auto 5px;
        width: 20px;
        height: 1px;
        background-color: lighten($color-charcoal, 20%);
        transition: transform 0.3s ease-out,
          background-color 0.3s ease-out;
        transform-origin: 0% 0%;
        transform: scale(0, 1);
      }

      :global(.no-touchevents) &:hover::after {
        transform: scale(1, 1);
        background-color: $color-light;
      }
    }

    .scrollbigClose {
      transition: opacity 0.3s ease-in-out 0.4s,
      transform 0.3s ease-in-out 0.4s,
      color 0.3s ease-in-out;
    }

    .scrollbigPrev {
      transition: opacity 0.3s ease-in-out 0.6s,
      transform 0.3s ease-in-out 0.6s,
      color 0.3s ease-in-out;
    }

    .scrollbigNext {
      transition: opacity 0.3s ease-in-out 0.5s,
      transform 0.3s ease-in-out 0.5s,
      color 0.3s ease-in-out;
    }
  }

  .scrollbigNavigator {
    position: absolute;
    bottom: 40px;
    left: 50px;

    .scrollbigClose {
      margin-bottom: 50px;
    }

    p {
      cursor: pointer;
      color: lighten($color-charcoal, 20%);

      :global(.no-touchevents) &:hover {
        color: $color-white;
      }
    }
  }
}

.starter {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: $color-blue;
}

.filler {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  background: #191919;
}
</style>



// WEBPACK FOOTER //
// src/components/BigScrollbar.vue